<template>
  <div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('addedServices', 'demandList')" name="first"> 
        <demandList v-if="activeName == 'first'" /> 
      </el-tab-pane>
      <el-tab-pane :label="$t('addedServices', 'draftBox')" name="second"> 
        <drafts v-if="activeName == 'second'" /> 
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import demandList from "./components/demandList";
import drafts from "./components/drafts";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  mixins: [i18nMixin],
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    demandList,
    drafts
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>